import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FetchGroupsListModel } from '../models/fetch-groups-list.model';
import { v1URL } from "../../../shared/constants/urls.constants";
import { CommonService } from "../../../shared/services/common.service";
import { FetchGroupsTypeFilterModel } from "../models/fetch-groups-type-filter.model";
import { FetchGroupsStatusFilterModel } from "../models/fetch-groups-status-filter.model";

@Injectable({
  providedIn: 'root',
})
export class CoachGroupsListService {
  constructor(
    private commonServices: CommonService
  ) {
  }

  fetchGroupsList(payload: FetchGroupsListModel['request']): Observable<FetchGroupsListModel['response']> {
    const urlConfig = v1URL.groups.fetchAll
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchGroupsTypeFilter(): Observable<FetchGroupsTypeFilterModel['response']> {
    const urlConfig = v1URL.filters.groupLocation
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchGroupsStatusFilter(): Observable<FetchGroupsStatusFilterModel['response']> {
    const urlConfig = v1URL.filters.groupStatus
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  generateAttendanceReport(payload: any): Observable<any> {
    const urlConfig = v1URL.reports.generateReports;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url('attendance'), payload);
  }

  fetchGroupFilter(payload: any): Observable<any> {
    const urlConfig = v1URL.reports.filters.groupFilters;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchParticipantFilter(payload: any): Observable<any> {
    const urlConfig = v1URL.reports.filters.participant;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }
}
